import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function GalleryPage() {
  useEffect(() => {
    // Initialize WOW.js
    setTimeout(() => {
      if (window.WOW) {
        try { new window.WOW().init(); } catch (e) {}
      }
    }, 500);

    // Initialize Magnific Popup if available
    setTimeout(() => {
      if (window.$ && window.$.fn && window.$.fn.magnificPopup) {
        window.$('.img-popup').magnificPopup({
          type: 'image',
          gallery: {
            enabled: true
          }
        });
      }
    }, 500);
  }, []);

  const galleryImages = [
    { id: 1, title: 'Group Therapy Session', category: 'Sessions', img: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?auto=format&fit=crop&q=80&w=800' },
    { id: 2, title: 'Mindfulness Workshop', category: 'Workshops', img: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=800' },
    { id: 3, title: 'Calm Clinic Interior', category: 'Clinic', img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=800' },
    { id: 4, title: 'One-on-One Counseling', category: 'Sessions', img: 'https://images.unsplash.com/photo-1527137341206-647fa91884aa?auto=format&fit=crop&q=80&w=800' },
    { id: 5, title: 'Community Support Walk', category: 'Events', img: 'https://images.unsplash.com/photo-1509099836639-18ba1795216d?auto=format&fit=crop&q=80&w=800' },
    { id: 6, title: 'Art Therapy Class', category: 'Workshops', img: 'https://images.unsplash.com/photo-1460518451285-cd7ba71ba515?auto=format&fit=crop&q=80&w=800' },
    { id: 7, title: 'Therapeutic Garden', category: 'Clinic', img: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&q=80&w=800' },
    { id: 8, title: 'Yoga & Meditation', category: 'Events', img: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800' },
    { id: 9, title: 'Digital Wellness Webinar', category: 'Events', img: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=800' }
  ];

  return (
    <div style={{ background: '#fdfbff' }}>
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(assets/images/backgrounds/slider-2-2.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Our Glimpses</h2>
            <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.2rem', marginBottom: '20px' }}>Moments of healing, connection, and community.</p>
            <ul className="thm-breadcrumb">
              <li><Link to="/">Home</Link></li>
              <li><span>/</span></li>
              <li><span>Gallery</span></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section style={{ padding: '100px 0' }}>
        <div className="container">
          <div className="text-center mb-5 wow fadeInUp">
            <span style={{ color: '#7c3aed', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '2px' }}>Visual Journey</span>
            <h2 style={{ fontSize: '3rem', fontWeight: 900, color: '#2d2d4d' }}>Healing in <span style={{ color: '#7c3aed' }}>Action</span></h2>
          </div>

          <div className="row g-4">
            {galleryImages.map((item) => (
              <div key={item.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${item.id * 100}ms`}>
                <div style={{
                  position: 'relative',
                  overflow: 'hidden',
                  borderRadius: '24px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                  aspectRatio: '4/3',
                  group: 'true'
                }}
                className="gallery-card"
                >
                  <img 
                    src={item.img} 
                    alt={item.title} 
                    style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }}
                  />
                  
                  {/* Overlay */}
                  <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'linear-gradient(to top, rgba(124, 58, 237, 0.9), transparent)',
                    opacity: 0,
                    transition: 'opacity 0.4s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    padding: '30px',
                    cursor: 'pointer'
                  }}
                  className="gallery-overlay"
                  >
                    <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>{item.category}</span>
                    <h4 style={{ color: '#fff', fontWeight: 800, margin: '5px 0' }}>{item.title}</h4>
                    <a href={item.img} className="img-popup" style={{
                      width: '45px', height: '45px', borderRadius: '50%', background: '#fff', color: '#7c3aed',
                      display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px', textDecoration: 'none'
                    }}>
                      <i className="fa fa-plus"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>
        {`
          .gallery-card:hover img {
            transform: scale(1.1);
          }
          .gallery-card:hover .gallery-overlay {
            opacity: 1 !important;
          }
        `}
      </style>

      {/* CTA Section */}
      <section style={{ padding: '80px 0', background: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)', textAlign: 'center', color: '#fff' }}>
        <div className="container">
          <h2 style={{ color: '#fff', fontWeight: 900, marginBottom: '20px' }}>Ready to start your own healing journey?</h2>
          <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.2rem', marginBottom: '30px' }}>Join the thousands who have found peace and support with PsychMitra.</p>
          <Link to="/appointment" className="thm-btn" style={{ background: '#fff', color: '#7c3aed', padding: '15px 40px', borderRadius: '15px' }}>Book Appointment</Link>
        </div>
      </section>
    </div>
  );
}

export default GalleryPage;
